export const FETCH_ALL_TEAMS = 'FETCH_ALL_TEAMS';
export const FETCH_TEAM = 'FETCH_TEAM';
export const CREATE_TEAM = 'CREATE_TEAM';
export const DELETE_TEAM = 'DELETE_TEAM';

export const FETCH_ALL_DRAFTS = 'FETCH_ALL_DRAFTS';
export const FETCH_ALL_DRAFTS_LOADING = 'FETCH_ALL_DRAFTS_LOADING';
export const FETCH_DRAFT = 'FETCH_DRAFT';
export const CREATE_DRAFT = 'CREATE_DRAFT';

export const FETCH_PLAYERS_BY_NAME = 'FETCH_PLAYERS_BY_NAME';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const ROOT_URL = process.env.REACT_APP_HOST;

export * from "./actions-team";
export * from "./actions-draft";
export * from "./actions-players";
export * from "./actions-auth";



// WEBPACK FOOTER //
// ./src/actions/actions-index.js